import { ModelType } from "../../store/global-types/customization-types";

const configApiRoot = '/config';
const contouringApiRoot = '/contouring';
const doseApiRoot = '/dose';
const imageApiRoot = '/translation';
const adaptApiRoot = '/reg';
const labelingApiPath = '/labeling';

const apiUrls = {
    // RESTful urls
    contouringConfig: configApiRoot + contouringApiRoot,
    doseConfig: configApiRoot + doseApiRoot,
    imageConfig: configApiRoot + imageApiRoot,
    adaptConfig: configApiRoot + adaptApiRoot,
    daemonsConfig: configApiRoot + '/connectors',
    daemonConfig: configApiRoot + '/connector',
    regenerateCredentials: configApiRoot + '/connector/credentials',
    tokenAssociate: '/token',
    resetDaemonConfig: configApiRoot + '/reset-connector',

    // backup urls
    backupsConfig: configApiRoot + '/backups',
    backupDownload: configApiRoot + '/backup/download',

    // other urls
    exportConfig: configApiRoot + '/export',
    getClientListUrl: configApiRoot + '/get-user-list',
    getListActiveModelsUrl: configApiRoot + '/list-active-models',

    contouringLabeling: contouringApiRoot + labelingApiPath,
    doseLabeling: doseApiRoot + labelingApiPath,
    imageLabeling: imageApiRoot + labelingApiPath,
    adaptLabeling: adaptApiRoot + labelingApiPath,
    workspaceLabeling: labelingApiPath,
    backendVersionUrl: '/build-info',

    getLicenseUrl: configApiRoot + '/licenses',
    // NOTE: saveLicenseUrl is only used in local mode
    saveLicenseUrl: configApiRoot + '/license',
    getAccessRightsUrl: '/access-rights',

    makeCloudUserSettingUrl: (userId: string, setting: string) => `/user/${userId}/settings/${setting}`,
    makeLocalUserSettingUrl: (setting: string) => `/settings/${setting}`,

    // functions for creating dynamic URLs
    makeGetDefaultConfigForContourModelUrl: (modelName: string) => `${apiUrls.contouringConfig}/${modelName}`,
    makeGetDefaultConfigForDoseModelUrl: (modelName: string) => `${apiUrls.doseConfig}/${modelName}`,
    makeGetDefaultConfigForImageModelUrl: (modelName: string) => `${apiUrls.imageConfig}/${modelName}`,
    makeGetDefaultConfigForAdaptModelUrl: (modelName: string) => `${apiUrls.adaptConfig}/${modelName}`,
}

export default apiUrls;

/** API userId field for 'default' configuration */
export const DEFAULT_USER_ID = 'default';

export const getLabelingUrl = (modelType: ModelType) => {
    switch (modelType) {
        case ModelType.Contouring:
            return apiUrls.contouringLabeling;
        case ModelType.Dose:
            return apiUrls.doseLabeling;
        case ModelType.Image:
            return apiUrls.imageLabeling;
        case ModelType.Adapt:
            return apiUrls.adaptLabeling;
        default:
            throw new Error(`Unsupported model type ${modelType}`);
    }
}
